import { CRM } from "@/components/atomic-crm/root/CRM";
import brandLogo from "@/components/atomic-crm/root/logos/georgia-web-co-logo.png";
import brandMark from "@/components/atomic-crm/root/logos/georgia-web-co-mark.png";
import {
  defaultCompanySectors,
  defaultDealCategories,
  defaultDealPipelineStatuses,
  defaultDealStages,
  defaultNoteStatuses,
  defaultTaskTypes,
} from "@/components/atomic-crm/root/defaultConfiguration";

/**
 * Georgia Web Co CRM — branded fork of Atomic CRM (MIT).
 */
const App = () => (
  <CRM
    disableTelemetry
    title="Georgia Web Co CRM"
    darkModeLogo={brandMark}
    lightModeLogo={brandLogo}
    currency="USD"
    companySectors={defaultCompanySectors}
    dealCategories={defaultDealCategories}
    dealPipelineStatuses={defaultDealPipelineStatuses}
    dealStages={defaultDealStages}
    noteStatuses={defaultNoteStatuses}
    taskTypes={defaultTaskTypes}
  />
);

export default App;
